var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlourish1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 593.6699829101562 593.6699829101562",
    id: "Layer_2_1704421737249",
    width: 140,
    height: 140,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1_1704421737249 {\n        fill: #fff0d7;\n        stroke-width: 0px;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_1704421737249"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M299.35,506.66c0-1.94-1.58-3.52-3.52-3.52s-3.52,1.58-3.52,3.52v81.48c0,1.94,1.58,3.52,3.52,3.52s3.52-1.58,3.52-3.52v-81.48Z",
    className: "cls-1_1704421737249",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(40, 22, 42)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "translate(-263.44 571.36) rotate(-67.5)",
    r: 9.71,
    cy: 482.82,
    cx: 295.83,
    className: "cls-1_1704421737249",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(40, 22, 42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.83,88.52c1.94,0,3.52-1.58,3.52-3.52V3.52c0-1.94-1.58-3.52-3.52-3.52s-3.52,1.58-3.52,3.52v81.48c0,1.94,1.58,3.52,3.52,3.52Z",
    className: "cls-1_1704421737249",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(40, 22, 42)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 9.71,
    cy: 108.85,
    cx: 295.83,
    className: "cls-1_1704421737249",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(40, 22, 42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.52,299.35h81.48c1.94,0,3.52-1.58,3.52-3.52s-1.58-3.52-3.52-3.52H3.52c-1.94,0-3.52,1.58-3.52,3.52s1.58,3.52,3.52,3.52Z",
    className: "cls-1_1704421737249",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(40, 22, 42)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "translate(-206.12 283.19) rotate(-67.5)",
    r: 9.71,
    cy: 295.83,
    cx: 108.85,
    className: "cls-1_1704421737249",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(40, 22, 42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.14,292.31h-81.48c-1.94,0-3.52,1.58-3.52,3.52s1.58,3.52,3.52,3.52h81.48c1.94,0,3.52-1.58,3.52-3.52s-1.58-3.52-3.52-3.52Z",
    className: "cls-1_1704421737249",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(40, 22, 42)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "translate(-41.15 81.16) rotate(-9.22)",
    r: 9.71,
    cy: 295.83,
    cx: 482.82,
    className: "cls-1_1704421737249",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(40, 22, 42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.88,436.22c30.33,0,59.1-9.81,83.21-28.37l8.96-6.9-11.29.59c-1.46.08-2.93.11-4.37.11-57.34,0-103.99-47.47-103.99-105.83,0-51.6,36.47-94.68,84.54-103.98v80.27s0,.04,0,.06c-1.37,2.93-3.04,5.69-4.97,8.24-4.34-.6-8.62-1.81-12.68-3.66,1.85,4.06,3.06,8.33,3.66,12.68-3.5,2.64-7.38,4.81-11.56,6.39,4.18,1.56,8.06,3.73,11.56,6.37-.6,4.32-1.8,8.57-3.63,12.61,4.04-1.83,8.3-3.03,12.62-3.63,2.64,3.49,4.81,7.36,6.38,11.52,1.57-4.16,3.74-8.03,6.38-11.51,4.35.61,8.63,1.82,12.7,3.68-1.85-4.06-3.06-8.34-3.67-12.68,3.5-2.64,7.38-4.8,11.56-6.36-4.18-1.57-8.07-3.74-11.57-6.38.6-4.33,1.8-8.6,3.63-12.65-4.06,1.84-8.33,3.04-12.66,3.64-1.92-2.54-3.58-5.28-4.95-8.19,0-.04.01-.08.01-.12v-80.77c5.42-.89,10.97-1.36,16.63-1.36,1.66,0,3.04.03,4.35.1l11.31.6-8.98-6.9c-24.1-18.54-52.86-28.34-83.18-28.34-76.12,0-138.05,62.98-138.05,140.39s61.93,140.39,138.05,140.39ZM296.88,162.49c25.13,0,49.15,7.11,70.07,20.65-58.24,3.4-104.6,52.65-104.6,112.7s46.36,109.29,104.61,112.68c-20.92,13.55-44.94,20.66-70.08,20.66-72.24,0-131.01-59.82-131.01-133.34s58.77-133.34,131.01-133.34Z",
    className: "cls-1_1704421737249",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(40, 22, 42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.21,205.32l75.17,31.46c.31.13.64.2.96.23-6.89,18.28-10.67,38.11-10.67,58.82s3.95,41.46,11.15,60.09l-74.79,30.66c-1.8.74-2.66,2.79-1.92,4.59.56,1.36,1.87,2.19,3.26,2.19.44,0,.9-.09,1.33-.26l74.8-30.66c7.65,17.56,18.23,33.52,31.1,47.22l-56.2,56.2c-1.38,1.38-1.38,3.61,0,4.98.69.69,1.59,1.03,2.49,1.03s1.8-.34,2.49-1.03l56.16-56.16c13.29,12.99,28.74,23.71,45.75,31.52l-30.62,73.16c-.75,1.79.09,3.86,1.89,4.61.44.19.9.27,1.36.27,1.38,0,2.68-.81,3.25-2.16l30.59-73.09c18.59,7.57,38.87,11.74,60.09,11.74s40.49-3.97,58.7-11.18l29.58,72.16c.56,1.36,1.87,2.19,3.26,2.19.44,0,.9-.09,1.34-.26,1.8-.74,2.66-2.79,1.92-4.59l-29.61-72.23c17.89-8.02,34.09-19.23,47.91-32.92l55.37,55.37c.69.69,1.59,1.03,2.49,1.03s1.8-.34,2.49-1.03c1.38-1.38,1.38-3.61,0-4.98l-55.45-55.45c12.49-13.48,22.77-29.08,30.27-46.22l72.21,30.22c.44.19.9.27,1.36.27,1.38,0,2.69-.81,3.25-2.16.75-1.79-.1-3.86-1.89-4.61l-72.24-30.23c7.24-18.68,11.22-39.02,11.22-60.28,0-19.89-3.48-38.98-9.86-56.65l74-30.34c1.8-.74,2.66-2.79,1.92-4.59-.74-1.8-2.8-2.66-4.59-1.92l-73.86,30.28c-7.45-18.19-18.03-34.74-31.03-48.97l56.27-56.27c1.38-1.38,1.38-3.61,0-4.98-1.38-1.38-3.61-1.38-4.98,0l-56.15,56.15c-13.56-13.61-29.45-24.82-47-32.94l29.96-71.6c.75-1.79-.1-3.86-1.89-4.61-1.79-.75-3.86.1-4.61,1.89l-29.93,71.51c-18.68-7.65-39.07-11.88-60.42-11.88s-41.13,4.09-59.59,11.53l-29.86-72.85c-.74-1.8-2.79-2.66-4.59-1.92-1.8.74-2.66,2.79-1.92,4.59l29.91,72.96c-17.54,7.99-33.43,19.06-47.02,32.52l-56.94-56.94c-1.38-1.38-3.61-1.38-4.98,0s-1.38,3.61,0,4.98l57.02,57.02c-12.9,13.92-23.44,30.1-30.99,47.9-.23-.17-.47-.33-.75-.44l-75.17-31.46c-1.79-.75-3.86.09-4.61,1.89-.75,1.79.09,3.86,1.89,4.61ZM295.83,137.97c21.03,0,41.1,4.29,59.41,12.04.36.44.81.81,1.37,1.05.44.19.9.27,1.36.27.09,0,.17-.01.26-.02,54.56,24.49,92.74,80.05,92.74,144.52,0,87.05-69.59,157.87-155.13,157.87s-155.12-70.82-155.12-157.87,69.58-157.87,155.12-157.87Z",
    className: "cls-1_1704421737249",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(40, 22, 42)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlourish1);
export default __webpack_public_path__ + "static/media/flourish1.174d73d215ee17ff45ef34d949090547.svg";
export { ForwardRef as ReactComponent };